export const information = [
  {
    title: 'Next Draw Date',
    value: '25 Sep 2021, Friday'
  },
  {
    title: 'Draws',
    value: '1'
  },
  {
    title: 'Entries per Draw',
    value: '3'
  },
  {
    title: 'Cost per Entry',
    value: 'Rs 30.00'
  },
  {
    title: 'Total Cost',
    value: 'MUR'
  }
];
